(function () {
  if (window.__ewCartFormInit) return;   // защита от двойной инициализации
  window.__ewCartFormInit = true;

  const CART_SECTION = 'dynamic-cart';

  document.addEventListener('submit', async function (e) {
    const form = e.target.closest('.js-ew-add-form');
    if (!form) return;
    e.preventDefault();

    const btn = form.querySelector('button[type="submit"]');
    const id = form.querySelector('[name="id"]').value;
    if (!id || (btn && btn.disabled)) return;

    if (btn) btn.classList.add('is-loading');
    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [{ id: Number(id), quantity: 1 }],
          sections: [CART_SECTION]
        })
      });
      if (!res.ok) throw new Error('Add to cart failed');
      const data = await res.json();

      if (data.sections && data.sections[CART_SECTION]) {
        const wrapper = document.getElementById('shopify-section-' + CART_SECTION);
        if (wrapper) wrapper.innerHTML = data.sections[CART_SECTION];
      }

      const drawer = document.querySelector('dynamic-cart');
      if (drawer && !drawer.hasAttribute('opened')) {
        document.querySelector('[data-cart-link]')?.click();
      }
    } catch (err) {
      console.error(err);
    } finally {
      if (btn) btn.classList.remove('is-loading');
    }
  });
})();